import React from 'react';

import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';

import styles from './researchItemStyles.scss';
import headerStyles from './ResearchItemHeader/researchItemHeaderStyles.scss';
import bodyStyles from './ResearchItemBody/researchItemBodyStyles.scss';
import footerStyles from './ResearchItemFooter/researchItemFooterStyles.scss';

const ResearchItemLoading: React.FC<{ narrow?: boolean; postedAt?: boolean; times?: number }> = ({
  postedAt,
  times = 1
}): React.ReactElement => {
  return (
    <>
      {[...Array(times).keys()].map(i => (
        <div className={styles.researchItem} key={i}>
          <section className={headerStyles.researchHeader}>
            <div className={headerStyles.researchHeaderTitle}>
              <Skeleton size={SKELETON_SIZES.LARGE} width={SKELETON_WIDTHS.MEDIUM} />
            </div>
            <div>
              <div className={headerStyles.researchHeaderDates}>
                {postedAt ? (
                  <Skeleton width={SKELETON_WIDTHS.SMALL} />
                ) : (
                  <>
                    <Skeleton width={SKELETON_WIDTHS.SMALL} />
                    <Skeleton width={SKELETON_WIDTHS.SMALL} />
                  </>
                )}
              </div>
            </div>
          </section>
          <section className={bodyStyles.researchItemBody}>
            <Skeleton />
            <Skeleton />
            <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} />
          </section>
          <section className={footerStyles.researchItemFooter}>
            <div className={footerStyles.researchItemAuthor}>
              <Skeleton width={SKELETON_WIDTHS.LARGE} />
            </div>
            <div className={footerStyles.researchItemActions}>
              <Skeleton width={SKELETON_WIDTHS.SMALL} />
            </div>
          </section>
        </div>
      ))}
    </>
  );
};

export default ResearchItemLoading;
